export const companyTypes = [
  { label: 'CD', value: 'CD' },
  { label: 'WH', value: 'WH' },
  { label: 'Loja', value: 'Loja' },
];
